import { render, staticRenderFns } from "./index_2022_09_20.vue?vue&type=template&id=2b47fa3d&scoped=true&"
import script from "./index_2022_09_20.vue?vue&type=script&lang=js&"
export * from "./index_2022_09_20.vue?vue&type=script&lang=js&"
import style0 from "@/assets/warningcenter.less?vue&type=style&index=0&id=2b47fa3d&lang=less&scoped=true&"
import style1 from "./index_2022_09_20.vue?vue&type=style&index=1&id=2b47fa3d&scoped=true&lang=css&"
import style2 from "./index_2022_09_20.vue?vue&type=style&index=2&id=2b47fa3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47fa3d",
  null
  
)

export default component.exports